export const agGridCommonConfig = {
    rowHeight: 35,        // default row height
    headerHeight: 40,     // header height
    tableHeight: 460,     // container height
    pagination: true,
    paginationPageSize: 10,
    paginationPageSizeSelector: false,
    animateRows: true,
    defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
    },
};
